<div class="poll-item">
  <label>
    <div id="number-holder">
      <div class="option-image-wrapper">
        <img id="resolution-{{index}}" class="resolution-image" src="{{this.imageAsset}}" alt="{{imageAsset}}">
      </div>
    </div>
    <div class="poll-item-description-holder">
      <span class="poll-item-question" id="poll-item-question-{{index}}">
        {{choice.text === '' ? '?' : choice.text}}
      </span>
    </div>
    <div [ngClass]="['checkbox' + ' checkbox-' + index]" >
      <input class="box" type="checkbox" id="{{'checkbox-' + index}}" (click)="actionVote()">
      <span class="checkmark"></span>
    </div>
  </label>
</div>
